'use strict';
var _eachDayOfInterval = _interopRequireDefault(require('date-fns/eachDayOfInterval'));

const { daysInWeek, getYear } = require('date-fns');
const { default: styles } = require('fork/react-date-range/src/styles');

function _typeof(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = exports.rangeShape = void 0;

var _react = _interopRequireWildcard(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _classnames4 = _interopRequireDefault(require('classnames'));

var _endOfDay = _interopRequireDefault(require('date-fns/endOfDay'));

var _isBefore = _interopRequireDefault(require('date-fns/isBefore'));

var _isAfter = _interopRequireDefault(require('date-fns/isAfter'));

var _isSameDay = _interopRequireDefault(require('date-fns/isSameDay'));

var _format = _interopRequireDefault(require('date-fns/format'));

var _startOfDay = _interopRequireDefault(require('date-fns/startOfDay'));

var _startOfMonth = _interopRequireDefault(require('date-fns/startOfMonth'));
var _endOfMonth = _interopRequireDefault(require('date-fns/endOfMonth'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}

function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if ((typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) || iter['@@iterator'] != null)
    return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

function addMonths(numOfMonths, date = new Date()) {
  date.setMonth(date.getMonth() + numOfMonths);

  return date;
}

var Checkbox = /*#__PURE__*/ (function(_Component) {
  _inherits(Checkbox, _Component);
  var _super = _createSuper(Checkbox);
  function Checkbox(props, context) {
    var _this;
    _this = _super.call(this, props, context);
    _defineProperty(_assertThisInitialized(_this), 'handleChangeEvent', function(event) {
      var _this$props = _this.props;
      var day = _this$props.day;
      var today = new Date();
      var endCalendar = addMonths(12);
      var startDateOfMonth = _this$props.startDateOfMonth;
      var endDateOfMonth = _this$props.endDateOfMonth;
      var start =
          endDateOfMonth.getYear() > today.getYear()
            ? startDateOfMonth
            : endDateOfMonth.getMonth() > today.getMonth()
            ? startDateOfMonth
            : today.getDate() >= startDateOfMonth.getDate()
            ? today
            : startDateOfMonth,
        end =
          endDateOfMonth.getYear() === endCalendar.getYear() &&
          endDateOfMonth.getMonth() === endCalendar.getMonth()
            ? endCalendar
            : endDateOfMonth;

      var daysOfMonth = (0, _eachDayOfInterval.default)({
        start: start,
        end: end
      });
      var dayChecked = day.getDay();
      var daysChecked = daysOfMonth.filter(d => d.getDay() === dayChecked);
      var onSelection = _this$props.onSelection;
      var stateChanges = {};
      onSelection(daysChecked);
      if (Object.keys(stateChanges).length) {
        _this.setState(stateChanges);
      }
    });

    _defineProperty(_assertThisInitialized(_this), 'onDisabledEvent', function(event) {
      var _this$props = _this.props;
      var day = _this$props.day;
      var today = new Date();
      var endCalendar = addMonths(12);
      var startDateOfMonth = _this$props.startDateOfMonth;
      var endDateOfMonth = _this$props.endDateOfMonth;
      var start =
          endDateOfMonth.getYear() > today.getYear()
            ? startDateOfMonth
            : endDateOfMonth.getMonth() > today.getMonth()
            ? startDateOfMonth
            : today.getDate() >= startDateOfMonth.getDate()
            ? today
            : startDateOfMonth,
        end =
          endDateOfMonth.getYear() === endCalendar.getYear() &&
          endDateOfMonth.getMonth() === endCalendar.getMonth()
            ? endCalendar
            : endDateOfMonth;
      var daysOfMonth = (0, _eachDayOfInterval.default)({
        start: start,
        end: end
      });
      var result =
        endCalendar.getYear() === end.getYear()
          ? endCalendar.getMonth() < end.getMonth()
            ? true
            : false
          : !daysOfMonth.some(days => days.getDay() === day.getDay());

      return result;
    });

    _this.state = {
      hover: false,
      active: false
    };
    return _this;
  }

  _createClass(Checkbox, [
    {
      key: 'render',

      value: function render() {
        return /*#__PURE__*/ _react.default.createElement(
          'input',
          _extends({
            type: 'checkbox',
            className: this.props.styles.checkbox,
            checked: this.props.weeks.includes(
              `${this.props.day.getDay()}_${
                this.props.day.getDate() > 15 ? this.props.day.getMonth() + 1 : this.props.day.getMonth()
              }_${this.props.day.getYear()}`
            ),
            name: `${this.props.day.getDay()}_${
              this.props.day.getDate() > 15 ? this.props.day.getMonth() + 1 : this.props.day.getMonth()
            }_${this.props.day.getYear()}`,
            value: `${this.props.day.getDay()}_${
              this.props.day.getDate() > 15 ? this.props.day.getMonth() + 1 : this.props.day.getMonth()
            }_${this.props.day.getYear()}`,
            disabled: this.onDisabledEvent(),
            onChange: this.handleChangeEvent
          })
        );
      }
    }
  ]);
  return Checkbox;
})(_react.Component);

var _default = Checkbox;
exports.default = _default;
